// extracted by mini-css-extract-plugin
export default {"card":"n6-z"};